export default {"src":"/_next/static/media/linkdinIcon.12c0c977.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};